import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';

export const ParallaxTitleWrapper = styled.div`
  ${({ theme: { locale } }) => setTypography('display', locale)}

  overflow: hidden;
  margin: 0;
  white-space: nowrap;
  display: flex;
  flex-wrap: nowrap;

  .scroller {
    display: flex;
    white-space: nowrap;
    display: flex;
    flex-wrap: nowrap;
  }
`;
